import React, { useState } from 'react';

export const CalculationContext = React.createContext({
    initialResponse: null,
    setInitialResponse: () => null,
    lang: '',
    setLang: () => null,
    endpoint: '',
    setEndpoint: () => null,
    country: '',
    setCountry: () => null,
    application: '',
    setApplication: () => null,
    sizeOfBuilding: '',
    setSizeOfBuilding: () => null,
    newBuilding: '',
    setNewBuilding: () => null,
    currency: '',
    setCurrency: () => null,
    energyUsePerSquareMeter: '',
    setEnergyUsePerSquareMeter: () => null,
    heatingType: '',
    setHeatingType: () => null,
    heatingProductionEfficiency: '',
    setHeatingProductionEfficiency: () => null,
    hotwaterProduction: '',
    setHotWaterProduction: () => null,
    hotwaterProductionEfficiency: '',
    setHotWaterProductionEfficiency: () => null,
    coolingProduction: '',
    setCoolingProduction: () => null,
    coolingProductionEfficiency: '',
    setCoolingProductionEfficiency: () => null,
    energyCostElectricity: '',
    setEnergyCostElectricity: () => null,
    energyCostGas: '',
    setEnergyCostGas: () => null,
    energyCostOil: '',
    setEnergyCostOil: () => null,
    energyCostDistrictHeating: '',
    setEnergyCostDistrictHeating: () => null,
    energyCostDistrictCooling: '',
    setEnergyCostDistrictCooling: () => null,
    GreenhouseGasCo2Gas: '',
    setGHGCo2Gas: () => null,
    GreenhouseGasCo2Oil: '',
    setGHGCo2Oil: () => null,
    GreenhouseGasDistrictHeating: '',
    setGHGDistrictHeating: () => null,
    GreenhouseGasDistrictCooling: '',
    setGHGDistrictCooling: () => null,
    GreenhouseGasCo2Electricity: '',
    setGHGCo2Electricity: () => null,
    heatingDivisionPercentage: '',
    setHeatingDivisionPercentage: () => null,
    coolingDivisionPercentage: '',
    setCoolingDivisionPercentage: () => null,
    domesticHotWaterDivisionPercentage: '',
    setDomesticHotWaterDivisionPercentage: () => null,
    buildingElectricityDivisionPercentage: '',
    setBuildingElectricityDivisionPercentage: () => null,
    chillerHeatpump: null,
    setChillerHeatpump: () => null,
    hydronicOptimisation: null,
    setHydronicOptimisation: () => null,
    waterflowOptimisation: null,
    setWaterflowOptimisation: () => null,
    airHandlingUnitWithBuiltInControls: null,
    setAirHandlingUnitWithBuiltInControls: () => null,
    aHUWatertempOptimisation: null,
    setAHUWatertempOptimisation: () => null,
    dCVAirOptimisation: null,
    setDCVAirOptimisation: () => null,
    dCVWatertempOptimisationRoom: null,
    setDCVWatertempOptimisationRoom: () => null,
    analyticsandVisualisation: null,
    setAnalyticsandVisualisation: () => null,
    calculate: () => null,
    calculation: null,
    Co2Savings: 0,
    Co2SavingsPercentage: 0,
    ElectricEnergySavings: 0,
    ElectricalEnergyUsage: 0,
    EnergyConsumption: 0,
    NewEnergyConsumption: 0,
    EnergySavingsPercentage: 0,
    FinancialSavings: 0,
    FinancialSavingsPercentage: 0,
    OperationalCarbonFootprint: 0,
    OperationalCost: 0,
    ThermalEnergySavings: 0,
    ThermalEnergyUsage: 0,
    TotalEnergySavings: 0,
    NewPrimaryEnergyNumber: 0,
    Co2PerSquareMeterPerYear: 0,
    PrimaryEnergyNumber: 0,
    IsOverLegalLimit: false,
    IsOverLegalLimitCo2: false,
    HasChillerOrHeatpump: false,
    sendEmailStatus: '',
    setSendEmailStatus: () => null,
    setSendEmailSuccessMessage: () => null,
    setSendEmailErrorMessage: () => null,
    archerEnergySavings: 0,
    setArcherEnergySavings: () => null,
    geographicalFactor: 0,
    setGeographicalFactor: () => null,
    electricityFactor: 0,
    setElectricityFactor: () => null,
    initialElectricityFactor: 0,
    setInitialElectricityFactor: () => null,
    districtHeatingFactor: 0,
    setDistrictHeatingFactor: () => null,
    districtCoolingFactor: 0,
    setDistrictCoolingFactor: () => null,
    gasFactor: 0,
    setGasFactor: () => null,
    oilFactor: 0,
    setOilFactor: () => null,
    businessElectricityDivisionPercentage: 0,
    setBusinessElectricityDivisionPercentage: () => null,
    invalidDivisionPercent: false,
    totalDivisionPercent: 0,
    heatingDivisionLocked: false,
    setHeatingDivisionLocked: () => null,
    coolingDivisionLocked: false,
    setCoolingDivisionLocked: () => null,
    hotWaterDivisionLocked: false,
    setHotWaterDivisionLocked: () => null,
    buildingElectricityDivisionLocked: false,
    setBuildingElectricityDivisionLocked: () => null,
    businessElectricityDivisionLocked: false,
    setBusinessElectricityDivisionLocked: () => null
});

const CalculationContextProvider = (props) => {

    const [initialResponse, setInitialResponse] = React.useState(null);
    const [lang, setLang] = React.useState('sv');
    const [endpoint, setEndpoint] = React.useState('');
    const [sendEmailStatus, setSendEmailStatus] = React.useState('');
    const [sendEmailSuccessMessage, setSendEmailSuccessMessage] = React.useState('');
    const [sendEmailErrorMessage, setSendEmailErrorMessage] = React.useState('');

    const [country, setCountry] = React.useState('');
    const [application, setApplication] = React.useState('');
    const [heatingType, setHeatingType] = React.useState('');
    const [hotwaterProduction, setHotWaterProduction] = React.useState('');
    const [coolingProduction, setCoolingProduction] = React.useState('');

    const [currency, setCurrency] = React.useState('');

    const [archerEnergySavings, setArcherEnergySavings] = React.useState(0);

    const [sizeOfBuilding, setSizeOfBuilding] = useState(0);
    const [newBuilding, setNewBuilding] = useState(true);
    const [energyUsePerSquareMeter, setEnergyUsePerSquareMeter] = useState(0);
    const [heatingProductionEfficiency, setHeatingProductionEfficiency] = useState(0);
    const [hotwaterProductionEfficiency, setHotWaterProductionEfficiency] = useState(0);
    const [coolingProductionEfficiency, setCoolingProductionEfficiency] = useState(0);
    const [energyCostElectricity, setEnergyCostElectricity] = useState(0);
    const [energyCostGas, setEnergyCostGas] = useState(0);
    const [energyCostOil, setEnergyCostOil] = useState(0);
    const [energyCostDistrictHeating, setEnergyCostDistrictHeating] = useState(0);
    const [energyCostDistrictCooling, setEnergyCostDistrictCooling] = useState(0);
    const [GreenhouseGasCo2Gas, setGHGCo2Gas] = useState(0);
    const [GreenhouseGasCo2Oil, setGHGCo2Oil] = useState(0);
    const [GreenhouseGasDistrictHeating, setGHGDistrictHeating] = useState(0);
    const [GreenhouseGasDistrictCooling, setGHGDistrictCooling] = useState(0);
    const [GreenhouseGasCo2Electricity, setGHGCo2Electricity] = useState(0);
    const [heatingDivisionPercentage, setHeatingDivisionPercentage] = useState(0);
    const [coolingDivisionPercentage, setCoolingDivisionPercentage] = useState(0);
    const [domesticHotWaterDivisionPercentage, setDomesticHotWaterDivisionPercentage] = useState(0);
    const [buildingElectricityDivisionPercentage, setBuildingElectricityDivisionPercentage] = useState(0);
    const [businessElectricityDivisionPercentage, setBusinessElectricityDivisionPercentage] = useState(0);
    const [chillerHeatpump, setChillerHeatpump] = useState(true);
    const [hydronicOptimisation, setHydronicOptimisation] = useState(true);
    const [waterflowOptimisation, setWaterflowOptimisation] = useState(true);
    const [airHandlingUnitWithBuiltInControls, setAirHandlingUnitWithBuiltInControls] = useState(true);
    const [aHUWatertempOptimisation, setAHUWatertempOptimisation] = useState(true);
    const [dCVAirOptimisation, setDCVAirOptimisation] = useState(true);
    const [dCVWatertempOptimisationRoom, setDCVWatertempOptimisationRoom] = useState(true);
    const [analyticsandVisualisation, setAnalyticsandVisualisation] = useState(true);

    const [energyUseSqMetersNew, setEnergyUseSqMetersNew] = React.useState(0);
    const [energyUseSqMetersExisting, setEnergyUseSqMetersExisting] = React.useState(0);

    const [Co2Savings, setCo2Savings] = useState(0);
    const [Co2SavingsPercentage, setCo2SavingsPercentage] = useState(0);
    const [ElectricEnergySavings, setElectricEnergySavings] = useState(0);
    const [ElectricalEnergyUsage, setElectricalEnergyUsage] = useState(0);
    const [EnergyConsumption, setEnergyConsumption] = useState(0);
    const [NewEnergyConsumption, setNewEnergyConsumption] = useState(0);
    const [NewPrimaryEnergyNumber, setNewPrimaryEnergyNumber] = useState(0);
    const [Co2PerSquareMeterPerYear, setCo2PerSquareMeterPerYear] = useState(0);
    const [PrimaryEnergyNumber, setPrimaryEnergyNumber] = useState(0);
    const [EnergySavingsPercentage, setEnergySavingsPercentage] = useState(0);
    const [FinancialSavings, setFinancialSavings] = useState(0);
    const [FinancialSavingsPercentage, setFinancialSavingsPercentage] = useState(0);
    const [OperationalCarbonFootprint, setOperationalCarbonFootprint] = useState(0);
    const [OperationalCost, setOperationalCost] = useState(0);
    const [ThermalEnergySavings, setThermalEnergySavings] = useState(0);
    const [ThermalEnergyUsage, setThermalEnergyUsage] = useState(0);
    const [TotalEnergySavings, setTotalEnergySavings] = useState(0);

    const [geographicalFactor, setGeographicalFactor] = useState(0);
    const [electricityFactor, setElectricityFactor] = useState(0);
    const [initialElectricityFactor, setInitialElectricityFactor] = useState(0);
    const [districtHeatingFactor, setDistrictHeatingFactor] = useState(0);
    const [districtCoolingFactor, setDistrictCoolingFactor] = useState(0);
    const [gasFactor, setGasFactor] = useState(0);
    const [oilFactor, setOilFactor] = useState(0);

    const [heatingDivisionLocked, setHeatingDivisionLocked] = useState(false);
    const [coolingDivisionLocked, setCoolingDivisionLocked] = useState(false);
    const [hotWaterDivisionLocked, setHotWaterDivisionLocked] = useState(false);
    const [buildingElectricityDivisionLocked, setBuildingElectricityDivisionLocked] = useState(false);
    const [businessElectricityDivisionLocked, setBusinessElectricityDivisionLocked] = useState(false);

    const [IsOverLegalLimit, setIsOverLegalLimit] = useState(false);
    const [IsOverLegalLimitCo2, setIsOverLegalLimitCo2] = useState(false);
    const [HasChillerOrHeatpump, setHasChillerOrHeatpump] = useState(false);

    const [calculation, setCalculation] = useState();

    const calculate = async (slug, email, company, phone, acceptHubspotLegal, additionalFields = null) => {

        const body = {

            'country': country,
            'application': application,
            'newBuilding': newBuilding,
            'sizeOfBuilding': sizeOfBuilding,
            'energyUsePerSquareMeter': energyUsePerSquareMeter,
            'heatingType': heatingType,
            'heatingProductionEfficiency': heatingProductionEfficiency,
            'hotwaterProduction': hotwaterProduction,
            'hotwaterProductionEfficiency': hotwaterProductionEfficiency,
            'coolingProduction': coolingProduction,
            'coolingProductionEfficiency': coolingProductionEfficiency,
            'energyCostElectricity': energyCostElectricity,
            'energyCostGas': energyCostGas,
            'energyCostOil': energyCostOil,
            'energyCostDistrictHeating': energyCostDistrictHeating,
            'energyCostDistrictCooling': energyCostDistrictCooling,
            'GreenhouseGasCo2Gas': GreenhouseGasCo2Gas,
            'GreenhouseGasCo2Oil': GreenhouseGasCo2Oil,
            'GreenhouseGasDistrictHeating': GreenhouseGasDistrictHeating,
            'GreenhouseGasDistrictCooling': GreenhouseGasDistrictCooling,
            'GreenhouseGasCo2Electricity': GreenhouseGasCo2Electricity,
            'heatingDivisionPercentage': heatingDivisionPercentage,
            'coolingDivisionPercentage': coolingDivisionPercentage,
            'domesticHotWaterDivisionPercentage': domesticHotWaterDivisionPercentage,
            'buildingElectricityDivisionPercentage': buildingElectricityDivisionPercentage,
            'businessElectricityDivisionPercentage': businessElectricityDivisionPercentage,
            'chillerHeatpump': chillerHeatpump,
            'hydronicOptimisation': hydronicOptimisation,
            'waterflowOptimisation': waterflowOptimisation,
            'airHandlingUnitWithBuiltInControls': airHandlingUnitWithBuiltInControls,
            'aHUWatertempOptimisation': aHUWatertempOptimisation,
            'dCVAirOptimisation': dCVAirOptimisation,
            'dCVWatertempOptimisationRoom': dCVWatertempOptimisationRoom,
            'analyticsandVisualisation': analyticsandVisualisation,
            'email': email || '',
            'company': company || '',
            'phone': phone || '',
            'acceptHubspotLegal': acceptHubspotLegal,
            'geographicalFactor': geographicalFactor || 1,
            'electricityFactor': (electricityFactor > 0 ? electricityFactor : initialElectricityFactor) || 1,
            'districtHeatingFactor': districtHeatingFactor || 1,
            'districtCoolingFactor': districtCoolingFactor || 1,
            'gasFactor': gasFactor || 1,
            'oilFactor': oilFactor || 1,

            // Add French-specific fields if provided
            ...(additionalFields && additionalFields)
        };

        let opts = {
            credentials: 'include',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept-Language': lang
            },
            body: JSON.stringify(
                body)
        };

        if (slug === 'calculate') {
            await fetch(`${endpoint}/api/energy/${slug}`, opts).then(res => {
                return res
                    .json()
                    .then((json) => ({ success: res.status === 200, data: json }));
            })
                .then((result, error) => {
                    if (result.success) {
                        setCalculation(result.data);
                    } else {
                        setCalculation();
                        console.log('Something went wrong');
                    }
                });
        }
        if (slug === 'send') {
            await fetch(`${endpoint}/api/energy/${slug}`, opts)
                .then((response) => {
                    if (response.status === 200) {
                        setSendEmailStatus(sendEmailSuccessMessage || 'Email sent successfully');
                    } else {
                        setSendEmailStatus(sendEmailErrorMessage || 'Something went wrong');
                        console.log('SOMETHING WENT WRONG');
                    }
                });

        };

    };

    const fetchParams = async () => {
        if (country && application && heatingType && hotwaterProduction && coolingProduction) {

            let opts = {
                credentials: 'include',
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': lang
                },
                body: JSON.stringify(
                    {
                        'country': country,
                        'application': application,
                        'heatingType': heatingType,
                        'hotWaterProduction': hotwaterProduction,
                        'coolingProduction': coolingProduction
                    })
            };

            const r = await fetch(`${endpoint}/api/energy/parameters`, opts);
            const data = await r.json();

            if (data) {
                setHeatingType(data.HeatingType);
                setHotWaterProduction(data.HotWaterProduction);
                setCoolingProduction(data.CoolingProduction);
                setHeatingProductionEfficiency(data.HeatingProductionEfficiency);
                setHotWaterProductionEfficiency(data.HotWaterProductionEfficiency);
                setCoolingProductionEfficiency(data.CoolingProductionEfficiency);
                setEnergyCostElectricity(data.EnergyCostElectricity);
                setEnergyCostGas(data.EnergyCostGas);
                setEnergyCostOil(data.EnergyCostOil);
                setEnergyCostDistrictHeating(data.EnergyCostDistrictHeating);
                setEnergyCostDistrictCooling(data.EnergyCostDistrictCooling);
                setGHGCo2Gas(data.GreenhouseGasCo2Gas);
                setGHGCo2Oil(data.GreenhouseGasCo2Oil);
                setGHGDistrictHeating(data.GreenhouseGasDistrictHeating);
                setGHGDistrictCooling(data.GreenhouseGasDistrictCooling);
                setGHGCo2Electricity(data.GreenhouseGasCo2Electricity);
                setHeatingDivisionPercentage(data.HeatingDivisionPercentage);
                setCoolingDivisionPercentage(data.CoolingDivisionPercentage);
                setDomesticHotWaterDivisionPercentage(data.DomesticHotWaterDivisionPercentage);
                setBuildingElectricityDivisionPercentage(data.BuildingElectricityDivisionPercentage);
                setBusinessElectricityDivisionPercentage(data.BusinessElectricityDivisionPercentage);
                setHasChillerOrHeatpump(data.HasChillerOrHeatpump);
            }
        }
    };

    const totalDivisionPercent = Number(heatingDivisionPercentage) + Number(coolingDivisionPercentage) + Number(domesticHotWaterDivisionPercentage) + Number(buildingElectricityDivisionPercentage) + Number(businessElectricityDivisionPercentage);

    const [invalidDivisionPercent, setInvalidDivisionPercent] = React.useState(totalDivisionPercent !== 100);

    React.useEffect(() => {
        setInvalidDivisionPercent(totalDivisionPercent !== 100);
    }, [heatingDivisionPercentage, coolingDivisionPercentage, domesticHotWaterDivisionPercentage, buildingElectricityDivisionPercentage, businessElectricityDivisionPercentage]);

    React.useEffect(() => {
        if (calculation) {
            setCo2Savings(calculation.Co2Savings);
            setCo2SavingsPercentage(calculation.Co2SavingsPercentage);
            setElectricEnergySavings(calculation.ElectricEnergySavings);
            setElectricalEnergyUsage(calculation.ElectricalEnergyUsage);
            setEnergyConsumption(calculation.EnergyConsumption);
            setNewEnergyConsumption(calculation.NewEnergyConsumption);
            setNewPrimaryEnergyNumber(calculation.NewPrimaryEnergyNumber);
            setCo2PerSquareMeterPerYear(calculation.Co2PerSquareMeterPerYear);
            setPrimaryEnergyNumber(calculation.PrimaryEnergyNumber);
            setEnergySavingsPercentage(calculation.EnergySavingsPercentage);
            setFinancialSavings(calculation.FinancialSavings);
            setFinancialSavingsPercentage(calculation.FinancialSavingsPercentage);
            setOperationalCarbonFootprint(calculation.OperationalCarbonFootprint);
            setOperationalCost(calculation.OperationalCost);
            setThermalEnergySavings(calculation.ThermalEnergySavings);
            setThermalEnergyUsage(calculation.ThermalEnergyUsage);
            setTotalEnergySavings(calculation.TotalEnergySavings);
            setCurrency(calculation.CurrencyCode);
            setIsOverLegalLimit(calculation.IsOverLegalLimit);
            setIsOverLegalLimitCo2(calculation.IsOverLegalLimitCo2);
        }
    }, [calculation]);

    React.useEffect(() => {
        fetchParams();
    }, [country, application, heatingType, hotwaterProduction, coolingProduction]);

    React.useEffect(() => {
        if (calculation)
            setEnergyUsePerSquareMeter(newBuilding ? energyUseSqMetersNew : energyUseSqMetersExisting);
    }, [newBuilding]);

    return (
        <CalculationContext.Provider value={{
            initialResponse,
            setInitialResponse,
            lang,
            setLang,
            endpoint,
            setEndpoint,
            country,
            setCountry,
            application,
            setApplication,
            sizeOfBuilding,
            setSizeOfBuilding,
            newBuilding,
            setNewBuilding,
            currency,
            setCurrency,
            energyUsePerSquareMeter,
            setEnergyUsePerSquareMeter,
            heatingType,
            setHeatingType,
            heatingProductionEfficiency,
            setHeatingProductionEfficiency,
            hotwaterProduction,
            setHotWaterProduction,
            hotwaterProductionEfficiency,
            setHotWaterProductionEfficiency,
            coolingProduction,
            setCoolingProduction,
            coolingProductionEfficiency,
            setCoolingProductionEfficiency,
            energyCostElectricity,
            setEnergyCostElectricity,
            energyCostGas,
            setEnergyCostGas,
            energyCostOil,
            setEnergyCostOil,
            energyCostDistrictHeating,
            setEnergyCostDistrictHeating,
            energyCostDistrictCooling,
            setEnergyCostDistrictCooling,
            GreenhouseGasCo2Gas,
            setGHGCo2Gas,
            GreenhouseGasCo2Oil,
            setGHGCo2Oil,
            GreenhouseGasDistrictHeating,
            setGHGDistrictHeating,
            GreenhouseGasDistrictCooling,
            setGHGDistrictCooling,
            GreenhouseGasCo2Electricity,
            setGHGCo2Electricity,
            heatingDivisionPercentage,
            setHeatingDivisionPercentage,
            coolingDivisionPercentage,
            setCoolingDivisionPercentage,
            domesticHotWaterDivisionPercentage,
            setDomesticHotWaterDivisionPercentage,
            buildingElectricityDivisionPercentage,
            setBuildingElectricityDivisionPercentage,
            chillerHeatpump,
            setChillerHeatpump,
            hydronicOptimisation,
            setHydronicOptimisation,
            waterflowOptimisation,
            setWaterflowOptimisation,
            airHandlingUnitWithBuiltInControls,
            setAirHandlingUnitWithBuiltInControls,
            aHUWatertempOptimisation,
            setAHUWatertempOptimisation,
            dCVAirOptimisation,
            setDCVAirOptimisation,
            dCVWatertempOptimisationRoom,
            setDCVWatertempOptimisationRoom,
            analyticsandVisualisation,
            setAnalyticsandVisualisation,
            calculate,
            calculation,
            energyUseSqMetersNew,
            setEnergyUseSqMetersNew,
            energyUseSqMetersExisting,
            setEnergyUseSqMetersExisting,
            Co2Savings,
            Co2SavingsPercentage,
            ElectricEnergySavings,
            ElectricalEnergyUsage,
            EnergyConsumption,
            NewEnergyConsumption,
            EnergySavingsPercentage,
            FinancialSavings,
            FinancialSavingsPercentage,
            OperationalCarbonFootprint,
            OperationalCost,
            ThermalEnergySavings,
            ThermalEnergyUsage,
            TotalEnergySavings,
            NewPrimaryEnergyNumber,
            Co2PerSquareMeterPerYear,
            PrimaryEnergyNumber,
            IsOverLegalLimit,
            IsOverLegalLimitCo2,
            HasChillerOrHeatpump,
            sendEmailStatus,
            setSendEmailStatus,
            setSendEmailSuccessMessage,
            setSendEmailErrorMessage,
            archerEnergySavings,
            setArcherEnergySavings,
            geographicalFactor,
            setGeographicalFactor,
            electricityFactor,
            setElectricityFactor,
            initialElectricityFactor,
            setInitialElectricityFactor,
            districtHeatingFactor,
            setDistrictHeatingFactor,
            districtCoolingFactor,
            setDistrictCoolingFactor,
            gasFactor,
            setGasFactor,
            oilFactor,
            setOilFactor,
            businessElectricityDivisionPercentage,
            setBusinessElectricityDivisionPercentage,
            invalidDivisionPercent,
            totalDivisionPercent,
            heatingDivisionLocked,
            setHeatingDivisionLocked,
            coolingDivisionLocked,
            setCoolingDivisionLocked,
            hotWaterDivisionLocked,
            setHotWaterDivisionLocked,
            buildingElectricityDivisionLocked,
            setBuildingElectricityDivisionLocked,
            businessElectricityDivisionLocked,
            setBusinessElectricityDivisionLocked
        }}>
            {props.children}
        </CalculationContext.Provider>
    );
};

export default CalculationContextProvider;
